import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentPlusIcon } from '@heroicons/react/24/outline';

const FileWriteNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const encoding = data.config?.encoding || 'utf-8';
  const overwrite = data.config?.overwrite || false;
  const filePath = data.config?.file_path || '';

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-rose-500 to-rose-600 border-2 transition-all duration-200 ${
      selected ? 'border-rose-700 shadow-xl scale-105' : 'border-rose-400'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentPlusIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-rose-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Settings display */}
          <div className="flex items-center mt-1 space-x-2">
            <span className="text-xs text-rose-100">
              💾 {encoding.toUpperCase()}
            </span>
            {overwrite && (
              <span className="text-xs text-rose-100">
                ⚠️ Felülír
              </span>
            )}
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* File path preview */}
      {filePath && (
        <div className="mt-2 text-xs text-rose-100 bg-black bg-opacity-20 px-2 py-1 rounded truncate">
          <strong>Fájl:</strong> {filePath}
        </div>
      )}

      {/* Execution result */}
      {data.executionData?.success !== undefined && (
        <div className="mt-2 text-xs text-rose-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <strong>Státusz:</strong> {data.executionData.success ? '✅ Sikeres' : '❌ Sikertelen'}
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-rose-700 border-2 border-white"
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-rose-700 border-2 border-white"
      />
    </div>
  );
};

export default FileWriteNode;
